function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  body{\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  }\n  a{\n    color: ", ";\n    text-decoration: none;\n    &:hover{\n      text-decoration: underline;\n    }\n  }\n  :root {\n  // crete css variables for colors\n  ", "\n  --helix-primary-color: ", ";\n  --helix-primary-btn-bg-color: ", ";\n  --helix-primary-btn-text-color: ", ";\n  --helix-primary-btn-hover-bg-color: ", ";\n  --helix-primary-btn-hover-text-color: ", ";\n  --helix-primary-btn-active-bg-color: ", ";\n  --helix-primary-btn-active-text-color: ", ";\n \n    --helix-breakpoint-xs: 0;\n    --helix-breakpoint-sm: 576px;\n    --helix-breakpoint-md: 768px;\n    --helix-breakpoint-lg: 992px;\n    --helix-breakpoint-xl: 1200px;\n    --helix-breakpoint-xxl: 1442px;\n\n  \n\n  }\n "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { createGlobalStyle } from 'styled-components';
import { colors } from './colors.js';
/* eslint-disable max-len */

var GlobalStyles = createGlobalStyle(_templateObject(), function (_ref) {
  var theme = _ref.theme;

  var _a, _b;

  return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.primary);
}, Object.keys(colors).map(function (color) {
  return _typeof(colors[color]) === 'object' ? Object.keys(colors[color]).map(function (shade) {
    return "--helix-".concat(color, "-").concat(shade, ": ").concat(colors[color][shade], ";");
  }) : "--helix-".concat(color, ": ").concat(colors[color], ";");
}), function (_ref2) {
  var theme = _ref2.theme;

  var _a, _b;

  return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.primary);
}, function (_ref3) {
  var theme = _ref3.theme;

  var _a, _b;

  return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonBackgroundColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.primary);
}, function (_ref4) {
  var theme = _ref4.theme;

  var _a, _b;

  return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonTextColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.white);
}, function (_ref5) {
  var theme = _ref5.theme;

  var _a, _b;

  return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonHoverBackgroundColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.blue[700]);
}, function (_ref6) {
  var theme = _ref6.theme;

  var _a, _b;

  return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonHoverTextColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.white);
}, function (_ref7) {
  var theme = _ref7.theme;

  var _a, _b;

  return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonActiveBackgroundColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.blue[800]);
}, function (_ref8) {
  var theme = _ref8.theme;

  var _a, _b;

  return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonActiveTextColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.white);
});
export { GlobalStyles };